module.exports = __webpack_public_path__ + "static/media/attachments.80305354.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/attachments.svg
// module id = 101
// module chunks = 0